import React from 'react';
import { connect } from 'react-redux';
import { accentForCurrency } from './currency-utils';

const PriceWithSymbol = ({ price, currency }) => {
  let priceToRender;

  if (currency === 'TRY') {
    priceToRender = price + accentForCurrency(currency);
  } else {
    priceToRender = accentForCurrency(currency) + price;
  }

  return <React.Fragment>{priceToRender}</React.Fragment>;
};

const mapStateToProps = state => {
  return {
    currency: state.venue.currency,
  };
};

export default connect(mapStateToProps)(PriceWithSymbol);



// WEBPACK FOOTER //
// ./src/utils/currency/PriceWithSymbol.js